
export const reducerLogout = (initialState) => {

  return initialState();
}
